// @angular/core
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'fang-tab',
	templateUrl: './fang-tab.component.html',
	styleUrls: ['./fang-tab.component.scss'],
	encapsulation: ViewEncapsulation.ShadowDom,
	changeDetection: ChangeDetectionStrategy.Default
})

export class FangTabComponent implements OnInit {

	@Input('tabTitle')
	public title: string;

	public active = false;

	constructor() {}

	// Ovveride
	ngOnInit(): void {
		console.log('FangTabComponent [ngOnInit]');
	}
}
